module.exports = __webpack_public_path__ + "static/media/maleprzeszklenia.f0bc6c6a.svg";